import { Component, inject, input, resource } from '@angular/core';
import { ViewGraphComponent } from '../view-graph/view-graph.component';
import { PrintA11TemplateComponent } from "../../print-templates/print-A11-template/print-A11-template.component";
import { BuildTestGraphs } from '../build-test-graphs/build-test-graphs.service';

/** Every test graph saved for a build, read through the getBuildTestGraphs callable (no Google account needed). */
@Component({
    selector: 'lib-view-graphs',
    imports: [
        ViewGraphComponent,
        PrintA11TemplateComponent,
    ],
    templateUrl: './view-graphs.component.html',
    styleUrl: './view-graphs.component.scss',
})
export class ViewGraphsComponent {
  readonly #testGraphs = inject(BuildTestGraphs);

  buildNumber = input.required<string>();
  printView = input<boolean>(false);

  graphs = resource({
    params: () => this.buildNumber(),
    loader: ({ params: buildNumber }) => this.#testGraphs.list(buildNumber),
  });
}
